import { Route, Routes } from "react-router-dom";
import moon from './Images/moon.png'
import sun from './Images/sun.png'
import PropTypes from "prop-types"
import './App.css';
import { useEffect, useState } from "react";
import Navbar from './Components/Navbar'
import Footer from "./Components/Footer";
import About from './Components/About'
import Home from './Components/Home'
import Contact from "./Components/Contact";

function App() {
  let [mode, setmode] = useState('bright')
  let [imgSrc, setImgSrc] = useState(moon)
  let changeMode = () => {
    if (mode === 'bright') {
      setmode('dark')
    }
    else {
      setmode('bright')
    }
  }
  useEffect(() => {
    if (mode === 'bright') {
      setImgSrc(moon)
    }
    else {
      setImgSrc(sun)
    }
  }, [mode])
  return (
    <div>
      <Navbar mode={mode} imgSrc={imgSrc} changeMode={changeMode} />
      <Routes>
        <Route path="/" element={<Home mode={mode} />} />
        <Route path='/about' element={<About mode={mode} />} />
        <Route path='/contact' element={<Contact mode={mode} />} />
      </Routes>
      <Footer mode={mode} />
    </div>
  );
}

export default App;
